import { Avatar, Box, Button, Typography } from '@mui/joy';
import React from 'react'
import { FiEdit } from "react-icons/fi";


const Profile = () => {
    return (
        <>
            <Box
                sx={{
                    width: '1030px',
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                    mb: 2,
                    p: 2,
                   
                }}
            >
                <Box
                    sx={{
                        position: 'relative',
                        width: 146,
                        height: 146,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >

                    <Avatar
                        src={'assets/images/Mask group (12).png'}
                        alt={'Profile'}
                        sx={{
                            width: '132.77px',
                            height: '132.77px',
                        }}
                    />
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: 146,
                            height: 146,
                            borderRadius: '50%',
                            border: '2px solid #28A745',
                            boxSizing: 'border-box',
                            pointerEvents: 'none',
                        }}
                    />
                </Box>


                <Box sx={{width:'80%'}}>
                    <Box sx={{ display: 'flex', alignItems: 'left', justifyContent: 'left', }}>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                width: '100%',
                                maxWidth: '100%',
                            }}
                        >
                            <Box sx={{ width: '500px', textAlign: 'left' }}>
                                <Typography variant="h2" sx={{ fontWeight: '600', fontSize: '22px' }}>
                                    Kevin
                                </Typography>

                                <Typography variant="h5" sx={{ fontWeight: '400' }}>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                </Typography>

                            </Box>
                            <Box sx={{ width: '190px', textAlign: 'start' }}>
                                <Typography
                                    sx={{
                                        fontSize: '22px',
                                        fontWeight: '600',
                                        lineHeight: '26.82px',
                                        color:'#666666',
                                        mb: 2,
                                    }}
                                >
                                    Location
                                </Typography>
                                <Typography
                                    sx={{
                                        width: '400px',
                                        maxWidth: '100%',
                                        color: '#666666',
                                        fontSize: '14px',
                                        fontWeight: 400

                                    }}
                                >
                                    City Name, Country Name
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: '#28A745',
                            color: '#fff',
                            width: '236px',
                            height: '39px',
                            margin: '1rem auto',
                            borderRadius: '6px',
                            fontSize: '18px',
                            fontWeight: 500,
                            lineHeight: '27px',
                            textAlign: 'center',
                        }}
                    >

                        <Typography sx={{ mr: 2, fontSize: '18px', color: '#fff', LineHeight: '27px' }}> Change Avatar</Typography>
                        <FiEdit color='#fff'
                            type="file"
                            onChange={(event) => console.log(event.target.files)}
                            multiple
                            fontSize={18}
                        />

                    </Button>
                </Box>
            </Box>
        </>
    )
}

export default Profile;